export enum UserRoles {
    VNB_USER = 'TNB_KASK_rolle_vnbnutzer',
    ADMIN_USER = 'TNB_KASK_rolle_wnadmin',
    WESTNETZ_USER = 'TNB_KASK_rolle_wnnutzer',
}
